import { Stack, Typography } from '@mui/material';
import Button from '../button';

type ConfirmOrCancelButtonProps = {
  onPressConfirm?: () => void;
  onPressCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  buttonCancelVariant?: 'text' | 'outlined' | 'contained';
};

export default function ConfirmOrCancelButton({
  onPressConfirm,
  onPressCancel,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  buttonCancelVariant = 'outlined',
}: ConfirmOrCancelButtonProps) {
  return (
    <Stack width="100%">
      <Button
        id="popup-botao-confirmar"
        variant="contained"
        onClick={onPressConfirm}
        sx={{ width: '100%', mb: 2 }}
      >
        <Typography variant="Headlines/Small" textTransform="initial">
          {confirmText}
        </Typography>
      </Button>
      <Button
        id="popup-botao-cancelar"
        variant={buttonCancelVariant}
        onClick={onPressCancel}
        sx={{ width: '100%' }}
      >
        <Typography variant="Headlines/Small" textTransform="initial">
          {cancelText}
        </Typography>
      </Button>
    </Stack>
  );
}
